import { Box } from "@mui/system";
import FrameDialog from "../../../ui/containers/FrameDialog";
import FrameHeader from "../../../ui/containers/FrameHeader";
import FrameDialogContent from "../../../ui/containers/FrameDialogContent";
import { Fab, Typography } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import FloatingActions from "../../../ui/FloatingActions";
import { useDispatch } from "react-redux";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState } from "react";
import StartHere from "../StartHere";
import EntryList from "../../entry/EntryList";
import { createNode } from "../../../lib/list";
import { attachNode } from "../../../store/list-slice";


function sortingFn(a, b) {
	return a.toLowerCase()
		.localeCompare(b.toLowerCase());
}


function NewCharacterButton({ faction, listEmpty, filter }) {
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch();

	function handleClose() {
		setOpen(false);
	}

	function handleOpen() {
		setOpen(true);
	}

	function handleEntrySelect(entry) {
		const node = createNode({
			type: "warlords",
			entrySlug: entry.slug,
		});

		dispatch(attachNode({ path: "", node }));
		handleClose();
	}

	const characterSlugs = faction.entryGroups.find(g => g.slug === "warlords").entrySlugs.filter(s => !filter.includes(s));

	const characters =
		[...characterSlugs].sort(sortingFn).map(s => faction.entries[s]);

	const actions = [
		{
			id: "close",
			icon: ArrowBackIcon,
			handler: handleClose,
		}
	];


	return (
		<>
			<Box textAlign="center">
				<Fab
					color="primary"
					variant="extended"
					size="large"
					onClick={handleOpen}
				>
					<AddCircleIcon sx={{ mr: 1 }} />
					<Typography variant="h4">Warlord</Typography>
				</Fab>
				{listEmpty && <StartHere />}
			</Box>
			<FrameDialog
				open={open}
				onClose={handleClose}
				responsive
				color="darkBgr"
				actions={actions}
			>
				<FrameHeader title="Select Warlord" />
				<FrameDialogContent>
					<EntryList
						title="Warlords"
						entries={characters}
						onEntrySelect={handleEntrySelect}
						factionSlug={faction.slug}
					/>
				</FrameDialogContent>
			</FrameDialog>
		</>
	);
}


export default NewCharacterButton;